import { qualifyUrls } from "routing/Routes";
const prefix = `my-filters`;
const SearchFiltersRoutes = {
  LIST: `/${prefix}`,
  NEW: `/${prefix}/new`,
  SHOW: (id) => `/${prefix}/details/${id}`,
  EDIT: (id) => `/${prefix}/edit/${id}`
};
const routes = qualifyUrls(SearchFiltersRoutes);
export default {
  ...routes,
  unqualified: SearchFiltersRoutes
};
